import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUsersQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.Users_Bool_Exp>;
}>;


export type GetUsersQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: string, firstName: string, lastName: string, fcmToken?: string | null, email: string, phone?: string | null, mentorEnabled?: boolean | null, menteeEnabled?: boolean | null, isContributor?: boolean | null, isEnabled?: boolean | null, specialtyId?: any | null, roleId?: number | null, workspaceLocationId?: number | null, userSpecialty?: { __typename?: 'specialties', id: any, name: string, parentId?: any | null, specialtyGroup?: { __typename?: 'specialties', id: any, name: string } | null } | null, workspaces: Array<{ __typename?: 'workspaceUsers', workspaceId: number, workspace: { __typename?: 'workspaces', id: number, name: string, locations: Array<{ __typename?: 'workspaceLocations', id: number, name: string, workspaceId: number, abbreviation?: string | null }> } }>, role?: { __typename?: 'roles', id: number, name: string, parentId?: number | null, roleGroup?: { __typename?: 'roles', id: number, name: string } | null } | null, workspaceLocation?: { __typename?: 'workspaceLocations', name: string, abbreviation?: string | null, id: number, city?: string | null, state?: string | null } | null }> };


export const GetUsersDocument = gql`
    query getUsers($where: users_bool_exp) {
  users(where: $where, order_by: {fullName: asc}) {
    id
    firstName
    lastName
    fcmToken
    email
    phone
    mentorEnabled
    menteeEnabled
    isContributor
    isEnabled
    specialtyId
    userSpecialty {
      id
      name
      parentId
      specialtyGroup {
        id
        name
      }
    }
    workspaces(where: {workspace: {active: {_eq: true}}}) {
      workspaceId
      workspace {
        id
        name
        locations(where: {active: {_eq: true}}) {
          id
          name
          workspaceId
          abbreviation
        }
      }
    }
    roleId
    role {
      id
      name
      parentId
      roleGroup {
        id
        name
      }
    }
    workspaceLocationId
    workspaceLocation {
      name
      abbreviation
      id
      city
      state
    }
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;